import { apiFetch } from "../../lib/utils";

export interface CreatePhoneReviewRequest {
  supplierOrgNr: string;
  supplierName?: string;
  customerOrgNr: string;
  customerName?: string;
  contactPerson?: string;
  period: string;
  endPeriod: string;
}

export interface CreatePhoneReviewsBulkRequest {
  reviews: CreatePhoneReviewRequest[];
}

export interface CreatePhoneReviewsBulkResponse {
  createdCount: number;
  ids?: number[];
  message?: string;
}
export interface ReviewPhoneReviewListRow {
  id: number;
  supplierName: string;
  supplierOrgNr: string;
  customerName: string;
  customerOrgNr: string;
  contactPerson?: string;
  period: string;
  endPeriod: string;
  status: number;
  isHandled: boolean;
  created: string;
  updated: string;
}
const baseUrl = "/ReviewPhoneReviews";

export const PhoneReviews = {
  async createBulk(
    payload: CreatePhoneReviewsBulkRequest
  ): Promise<CreatePhoneReviewsBulkResponse> {
    const response = await apiFetch(`${baseUrl}/api/create-bulk`,'POST', JSON.stringify(payload));
    return await response.json();
  },
   async getAll(): Promise<ReviewPhoneReviewListRow[]> {
    const response = await apiFetch(`${baseUrl}/api/all`);
    return await response.json();
  },

  async getById(id: number): Promise<any> {
    const response = await apiFetch(`${baseUrl}/api/${id}`);
    return await response.json();
  },

  async addAttempt(
    id: number,
    payload: {
      attemptAt: string;
      contactName: string;
      notes?: string | null;
      outcome?: number | null;
    }
  ): Promise<any> {
    const response = await apiFetch(`${baseUrl}/api/${id}/attempts`,'POST', JSON.stringify(payload));
    return await response.json();
  },

  async addReply(
    id: number,
    payload: { text: string }
  ): Promise<any> {
    const response = await apiFetch(`${baseUrl}/api/${id}/reply`, 'POST',JSON.stringify(payload));
    return await response.json();
  },

  async handle(
    id: number,
    payload: { comment: string }
  ): Promise<any> {
    const response = await apiFetch(`${baseUrl}/api/${id}/handle`, 'POST',JSON.stringify(payload));
    return await response.json();
  }
};